import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop.jsx"; // Assicurati di importare ScrollToTop
import Home from "./components/home/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import Menu from "./components/menu/Menu.jsx";
import Gallery from "./components/gallery/Gallery.jsx";
import Fuorimenu from "./components/Fuorimenu/Fuorimenu.jsx";
import Login from "./components/server/login/Login.jsx";
import Choose from "./components/server/scelta/Choose.jsx";
import Importplate from "./components/server/importplate/Importplate.jsx";
import Importphoto from "./components/server/importphoto/Importphoto.jsx";
import Homeap from "./components/appartment/home/Homeap.jsx";
import "../src/Language/118n.js"; // Import the i18n configuration
import Register from "./components/server/register/Register.jsx";
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* Aggiunto ScrollToTop qui */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/fuorimenu" element={<Fuorimenu />} />
        <Route path="/login" element={<Login />} />
        <Route path="/scelta" element={<Choose />} />
        <Route path="/photo" element={<Importphoto />} />
        <Route path="/plate" element={<Importplate />} />
        <Route path="/appartament" element={<Homeap />} />
        <Route path="/registra" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
